import * as AccordionPrimitive from "@radix-ui/react-accordion";
import type { ComponentPropsWithoutRef, Ref } from "react";
import { cn } from "../lib/utils";
import Icon from "./icon";
import { Typography } from "./typography";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & {
  ref?: Ref<HTMLDivElement>;
}) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border-b border-gray-200", className)}
    {...props}
  />
);
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = ({
  className,
  children,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
  ref?: Ref<HTMLButtonElement>;
}) => (
  <AccordionPrimitive.Header className="flex ">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "group flex flex-1 items-center justify-between py-3 font-medium text-gray-900 transition-all text-left [&[data-state=open]>svg]:rotate-180",
        className,
      )}
      {...props}
    >
      <Typography
        variant="h6"
        className="text-gray-900 group-hover:text-pink-500"
      >
        {children}
      </Typography>
      <Icon
        icon="chevron-down"
        className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-20 text-gray-200 group-hover:text-pink-500"
      />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = ({
  className,
  children,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & {
  ref?: Ref<HTMLDivElement>;
}) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("pb-3 pt-0", className)}>{children}</div>
  </AccordionPrimitive.Content>
);
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
